import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { tokenStorage } from '@/services/tokenStorage';
import { ROUTES } from '@/constants/routes';
import { isPollAdmin, isPollSuperAdmin } from '@/utils/pollAdmin';
import { useAuth } from '@/store/AuthContext';

interface PollAdminRouteProps {
  children: ReactNode;
}

export function PollAdminRoute({ children }: PollAdminRouteProps) {
  const location = useLocation();
  const { user } = useAuth();
  const isAuthenticated = tokenStorage.isAuthenticated();
  const sessionUser = user ?? tokenStorage.getUser();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (!isPollAdmin(sessionUser?.role, sessionUser?.email, sessionUser?.modules)) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return children;
}

export function PollAdminUserManagementRoute({ children }: PollAdminRouteProps) {
  const location = useLocation();
  const { user } = useAuth();
  const isAuthenticated = tokenStorage.isAuthenticated();
  const sessionUser = user ?? tokenStorage.getUser();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (!isPollSuperAdmin(sessionUser?.email)) {
    return <Navigate to={ROUTES.POLLS} replace />;
  }

  return children;
}
